import React, { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import AuthShell, { authInput } from "@/pages/AuthShell";
import { Loader2 } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <AuthShell eyebrow="Password Reset" title="Reset your password"
      footer={<Link to="/login" style={{ color: "#2038E6" }}>Back to login</Link>}>
      {sent ? (
        <p data-testid="forgot-sent" style={{ color: "var(--muted)" }}>
          If an account exists for that email, a reset link is on its way. Check your inbox.
        </p>
      ) : (
        <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
          <input data-testid="forgot-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} style={authInput} />
          {error && <span style={{ color: "#b00020", fontSize: 14 }}>{error}</span>}
          <button className="btn-cobalt" type="submit" disabled={loading} data-testid="forgot-submit" style={{ justifyContent: "center" }}>
            {loading ? <Loader2 size={18} className="animate-spin" /> : "Send reset link"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
